/**
 * Cheap language guess from the writing system, used for routing (assign Arabic messages to Arabic-speaking agents).
 * The NLP service (Phase 3) refines this with dialect detection; this never calls a model.
 */
export function scriptLanguage(
  text: string | null | undefined,
): 'ar' | 'ur' | 'ml' | 'hi' | 'ta' | 'en' | null {
  if (!text) return null;
  const counts = { arab: 0, urdu: 0, mlym: 0, deva: 0, taml: 0, latn: 0 };
  for (const ch of text) {
    const c = ch.codePointAt(0)!;
    if ('ٹڈڑںےھۓ'.includes(ch)) counts.urdu++;
    if (c >= 0x0600 && c <= 0x06ff) counts.arab++;
    else if (c >= 0x0d00 && c <= 0x0d7f) counts.mlym++;
    else if (c >= 0x0900 && c <= 0x097f) counts.deva++;
    else if (c >= 0x0b80 && c <= 0x0bff) counts.taml++;
    else if (/[A-Za-z]/.test(ch)) counts.latn++;
  }
  const [top, n] = Object.entries(counts)
    .filter(([k]) => k !== 'urdu')
    .sort((a, b) => b[1] - a[1])[0]!;
  if (!n) return null;
  if (top === 'arab') return counts.urdu > 0 ? 'ur' : 'ar';
  return ({ mlym: 'ml', deva: 'hi', taml: 'ta', latn: 'en' } as const)[
    top as 'mlym' | 'deva' | 'taml' | 'latn'
  ];
}
